
// BE owns status filtering. Three sub-tabs:
//   'all'     → no filter (BE returns ViewContent = both)
//   'review'  → ?status=content_review (creator submitted, brand reviews)
//   'pending' → ?status=content_pending (creator still needs to submit)
// No FE bucket function — render whatever the BE returns and read
// c.status directly when filtering for sub-tab counts.
export type ContentBucket = 'all' | 'review' | 'pending';

export const METRICS = [
  { key: 'views' as const, label: 'Views', icon: '👁' },
  { key: 'likes' as const, label: 'Likes', icon: '❤️' },
  { key: 'comments' as const, label: 'Comments', icon: '💬' },
  { key: 'shares' as const, label: 'Shares', icon: '🔗' },
];

// Re-exported from the one canonical projection so this surface cannot drift
// from the other thread surfaces again (it previously omitted anchor /
// reply_to / sender_avatar). Kept exported here because ContentTab already
// imports it from this module.
export { mapThreadMessages } from '../../../components/common/mapThreadMessages';

export function truncatePreview(s: string | undefined, n: number) {
  if (!s?.trim()) return '';
  const t = s.trim();
  return t.length <= n ? t : `${t.slice(0, n)}…`;
}

export function contentStatusLabel(status: string): string {
  if (status === 'content_approved') return 'Approved';
  if (status === 'content_live') return 'Live';
  if (status === 'content_revision_requested') return 'Changes requested';
  return 'Ready for review';
}

export function submitLabel(hasExisting: boolean): string {
  return hasExisting ? 'Re-submit' : 'Add URL';
}
